module.exports = __webpack_public_path__ + "static/media/2021_180k.7e8ded66.png";